// Utility functions for PDF report generation

export type PdfReportType = 'fit' | 'interview';

const PREFIXES: Record<PdfReportType, string> = {
  fit: 'TalentumIQ-FitScore',
  interview: 'TalentumIQ-Entrevista',
};

/**
 * Remove diacritics/accents and replace non-alphanumeric chars with hyphens.
 * e.g. "João Silva" → "Joao-Silva"
 */
function sanitizeName(name: string): string {
  return name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // strip combining diacritical marks
    .replace(/[^a-zA-Z0-9]+/g, '-') // replace special chars with hyphen
    .replace(/^-+|-+$/g, ''); // trim leading/trailing hyphens
}

/**
 * Generate a standardized PDF filename.
 * - fit:       TalentumIQ-FitScore-{SanitizedName}.pdf
 * - interview: TalentumIQ-Entrevista-{SanitizedName}.pdf
 */
export function generateFileName(type: PdfReportType, candidateName: string): string {
  const sanitized = sanitizeName(candidateName);
  return `${PREFIXES[type]}-${sanitized}.pdf`;
}
